/**
 * Normaliza e-mail: trim + minúsculas (evita falha de duplicidade case-sensitive).
 */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase()

/**
 * Normaliza nome: primeira letra de cada palavra maiúscula, restante minúsculo.
 * Ex.: "JOAO PAULO" → "Joao Paulo"
 */
export const normalizePersonName = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(
      (part) =>
        part.charAt(0).toLocaleUpperCase('pt-BR') +
        part.slice(1).toLocaleLowerCase('pt-BR'),
    )
    .join(' ')
